import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const ListAvailableSlots = (date, courseId) => {
  const url = apiConstants.ListAvailableSlots;
  date.setHours(3, 0, 0, 0);
  return httpClient.post(`${url}?date=${date.toISOString()}&courseId=${courseId}`).then(result => result.data.result.items);
};

export { ListAvailableSlots };
